import { render, staticRenderFns } from "./CalculadoraPreco.vue?vue&type=template&id=37c6481e&scoped=true&"
import script from "./CalculadoraPreco.vue?vue&type=script&lang=js&"
export * from "./CalculadoraPreco.vue?vue&type=script&lang=js&"
import style0 from "./CalculadoraPreco.vue?vue&type=style&index=0&id=37c6481e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c6481e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
